<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      系统设置
    </h1>
    <div class="template-box">
      <el-row>
        <el-col :span="12" v-for="item in templateList">
          <div class="card-item" @click="selectItem(item.id)">
            <div
              :class="{
                'card-icon': true,
                icon_caidie_docking: item.id == 1,
                icon_FTP_date: item.id == 2
              }"
            ></div>
            <div class="template-msg-box">
              <h4>{{ item.name }}</h4>
              <p>{{ item.number }}上次修改时间：{{ item.update_time }}</p>
            </div>
            <div class="setBtn">
              设置
              <i class="el-icon-arrow-right" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="彩蝶对接设置"
      :visible.sync="dialogVisible"
      width="440px"
      @close="getSetting"
    >
      <span>请选择要对接至彩蝶的数据：</span>
      <div>
        <el-form ref="form" :model="form">
          <el-form-item label="">
            <el-checkbox-group v-model="form.type">
              <el-checkbox
                :label="item.id"
                name="type"
                v-for="item in checkboxArr"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm" :loading="isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSetting, setSetting } from "@/api/index";

export default {
  name: "systemSet",
  data: () => ({
    dialogVisible: false,
    checkboxArr: [
      { id: 1, name: "销售日报" },
      { id: 4, name: "销售周报" },
      { id: 7, name: "销售月报" },
      { id: 2, name: "采购日报" },
      { id: 5, name: "采购周报" },
      { id: 8, name: "采购月报" },
      { id: 3, name: "库存日报" },
      { id: 6, name: "库存周报" },
      { id: 9, name: "库存月报" }
    ],
    templateList: [],
    form: {
      type: []
    },
    isLoading: false
  }),
  created() {
    if (this.$store.state.funcModuleArray.includes(1901070101)) {
      this.templateList.push({
        name: "彩蝶对接设置",
        id: 1
      });
    }
    if (this.$store.state.funcModuleArray.includes(1901070102)) {
      this.templateList.push({
        name: "FTP日期过滤",
        id: 2,
        update_time: ""
      });
    }
    this.getSetting();
    this.getDateFilteringSetting();
  },
  methods: {
    //彩蝶对接设置获取数据
    getSetting() {
      let para = {
        type: 20
      };
      getSetting(para).then(res => {
        if (0 === res.status) {
          this.form.type = JSON.parse(res.data.config);
          this.templateList[0].update_time = res.data.update_time;
        }
      });
    },
    //FTP日期过滤获取时间
    getDateFilteringSetting() {
      let para = {
        type: 42
      };
      getSetting(para).then(res => {
        if (0 === res.status) {
          this.templateList[1].update_time = res.data.update_time;
        }
      });
    },
    selectItem(id) {
      switch (id) {
        case 1:
          this.dialogVisible = true;
          break;
        case 2:
          this.$router.push({ name: "DateFiltering" });
          break;
      }
      console.log(id);
    },

    /*
     *
     * 彩蝶对接设置 提交
     * */
    confirm() {
      this.isLoading = true;
      setSetting(JSON.stringify(this.form.type)).then(res => {
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.isLoading = false;
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.template-box {
  .template-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    padding: 0 5px;
  }
  .card-item {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    padding: 15px 20px;
    width: 97%;
    position: relative;
    margin-bottom: 15px;
    cursor: pointer;
    .setBtn {
      color: #a6a6a6;
      font-size: 16px;
      position: absolute;
      right: 45px;
      top: 50%;
      margin-top: -12px;
    }
    .arrow {
      content: "";
      width: 15px;
      height: 15px;
      color: #d0d0d0;
      position: absolute;
      right: -20px;
      top: 5px;
    }
  }
  .card-icon {
    width: 65px;
    height: 65px;
    vertical-align: top;
    display: inline-block;
    border-radius: 4px;
  }
  .icon_caidie_docking {
    background: url("~@/assets/img/icon_caidie_docking.svg") no-repeat;
    background-size: 100% 100%;
  }
  .icon_FTP_date {
    background: url("~@/assets/img/icon_FTP_date.svg") no-repeat;
    background-size: 100% 100%;
  }
  /*.icon_date_chain {*/
  /*  background: url('~@/assets/img/icon_date_chain.svg') no-repeat;*/
  /*  background-size: 100% 100%;*/
  /*}*/
  /*.icon_date_distributor {*/
  /*  background: url('~@/assets/img/icon_date_distributor.svg') no-repeat;*/
  /*  background-size: 100% 100%;*/
  /*}*/
  /*.icon_date_doctor {*/
  /*  background: url('~@/assets/img/icon_date_doctor.svg') no-repeat;*/
  /*  background-size: 100% 100%;*/
  /*}*/
  /*.icon_date_pharmacy {*/
  /*  background: url('~@/assets/img/icon_date_pharmacy.svg') no-repeat;*/
  /*  background-size: 100% 100%;*/
  /*}*/
  .template-msg-box {
    display: inline-block;
    vertical-align: top;
    margin-top: 11px;
    margin-left: 35px;
    h4 {
      margin-bottom: 2px;
      font-size: 15px;
      font-weight: 600;
    }
    p {
      font-size: 12px;
      color: #a4a4a4;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
